import { primary } from "../../../theme/themeColors";

export interface IStylesType {
  [key: string]: React.CSSProperties | IStylesType;
}

export const styles: IStylesType = {
  header: {
    width: "100%",
  },
  logoContainer: {
    width: "100%",
    borderBottom: "1px solid #eff0ef54",
    paddingBottom: "0.5rem",
  },
  institutionLogoContainer: {
    display: "flex",
    width: "100%",
    gap: "0.5rem",
    alignItems: "center",
    padding: "0.8rem 0rem",
  },
  menuListContainer: {
    overflowY: "auto",
    flex: 1,
    width: "100%",
    marginTop: 8,
  },
  menuItemButton: {
    gap: "0.5rem",
    borderRadius: "10px",
    "&:hover": {
      "& .MuiListItemText-root > span": {
        color: "#000000 !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#000000 !important",
      },
    },
    "&.active": {
      backgroundColor: "#1F5A2D",
      "& .MuiListItemText-root > span": {
        color: "#ffffff !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#ffffff !important",
      },
    },
  },
  menuItemIcon: {
    minWidth: "0px",
    "&.MuiListItemIcon-root .MuiSvgIcon-root": {
      color: "#000000",
    },
  },
  menuItemText: {
    "& > span": {
      fontWeight: "500",
      color: "#000000",
    },
  },
  collapseContainer: {
    marginLeft: "28px",
    borderLeft: "1px solid #7fa684",
  },
  submenuItemButton: {
    "&:hover": {
      "& .MuiListItemText-root > span": {
        color: "#000000 !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#000000 !important",
      },
    },
    "&.active": {
      backgroundColor: "#1F5A2D",
      "& .MuiListItemText-root > span": {
        color: "#ffffff !important",
      },
    },
  },
  subMenuGroupButton: {
    position: "relative",
    "&:hover": {
      "& .MuiListItemText-root > span": {
        color: "#000000 !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#000000 !important",
      },
    },
    "&.active": {
      backgroundColor: "#1F5A2D",
      "& .MuiListItemText-root > span": {
        color: "#ffffff !important",
      },
    },
    "&.MuiListItemButton-root::before": {
      position: "absolute",
      width: "6px",
      height: "6px",
      borderRadius: "50%",
      top: 0,
      bottom: 0,
      left: "-3.5px",
      backgroundColor: "#000000",
      content: '""',
      marginTop: "auto",
      marginBottom: "auto",
      zIndex: 1,
    },
  },
  groupCollapseContainer: {
    marginLeft: "-2.5px",
    borderLeft: "4px solid #7fa684",
  },
  groupItemButton: {
    "&:hover": {
      "& .MuiListItemText-root > span": {
        color: "#000000 !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#000000 !important",
      },
    },
    "&.active": {
      backgroundColor: "#1F5A2D",
      "& .MuiListItemText-root > span": {
        color: "#ffffff !important",
      },
    },
  },
  menuItemGeneralSettingText: {
    "& > span": {
      fontWeight: "500",
      color: "#1c2437",
      marginTop: "0px",
      marginBottom: "0px",
    },
  },
  menuItemGeneralSettingButton: {
    padding: "2px",
  },
};

export const compactMenuStyles: IStylesType = {
  drawer: {
    "& .MuiPaper-root": {
      width: "20%",
    },
  },
  logoContainer: {
    width: "100%",
    borderBottom: "1px solid #eff0ef54",
    paddingBottom: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 1.5,
  },
  menuItemText: {
    "& > span": {
      fontWeight: "500",
      color: "#000",
      fontSize: 13,
    },
  },
  institutionLogoContainer: {
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
    padding: "0.8rem",
    width: "100%",
    paddingBottom: "0.5rem",
    justifyContent: "center",
  },
  menuItemButton: {
    paddingTop: "4px",
    paddingBottom: "4px",
    marginLeft: -2,
    "&:hover": {
      backgroundColor: primary.main,
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
      "& .MuiListItemIcon-root .MuiSvgIcon-root": {
        color: "#fff !important",
      },
    },
    "&.active": {
      backgroundColor: primary.main,
      "& .MuiListItemText-root > span": {
        color: "#fff !important",
      },
    },
  },
  backToMenuButton: {
    display: "flex",
    marginBottom: 2,
    marginLeft: -1,
    height: 35,
    lineHeight: 0,
    width: "100%",
    backgroundColor: primary.main,
    "&:hover": {
      backgroundColor: primary.main,
    },
  },
};
